import { Box, Flex, List, ListItem, Text } from '@chakra-ui/react';
import { fontSize } from '@constants/styles';

const Plans = ({ plans }) => {
  const renderPlan = (plan, index) => (
    <ListItem key={plan.name + index}>
      <Flex alignItems="center">
        <Text fontSize={fontSize.p}>{index + 1}.</Text>
        <Box flex={1} overflow="hidden" ml={1}>
          <Text fontSize={fontSize.p} sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {plan.name}
          </Text>
        </Box>
        <Text fontSize={fontSize.p}>
          <b>${plan.lowestPremium.toFixed(2)}/month</b>
        </Text>
      </Flex>
    </ListItem>
  );

  return (
    <List py={[3, 3, 8]} spacing={4}>
      {plans.map((plan, index) => renderPlan(plan, index))}
    </List>
  );
};

export default Plans;
